var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import { Table, Text } from '@ingka/common-styles-webc';
import EnergyFicheCardStyle from './EnergyFicheCardStyle.js';
/**
 * Data-driven fiche card.
 */
export default class EnergyFicheCard extends KompisElement {
    constructor() {
        super(...arguments);
        // Disables links. This attribute should be set to "true" when in a Kiosk.
        this.disableLinks = false;
    }
    render() {
        const tableClassName = Table.classnames({ fullWidth: true });
        return html `
			<style>
				${EnergyFicheCardStyle.getStyle()}
			</style>

			<table class="${tableClassName}">
				<tbody>
					${this.getDataRows()}
				</tbody>
			</table>
		`;
    }
    /**
     * Retrieves data from complianceTechnical and technicalInformation.
     */
    getDataRows() {
        const complianceTechnicalItems = this.getComplianceTechnical();
        const technicalInformationitems = this.getFilteredTechnicalInformation(complianceTechnicalItems);
        const bodyTextClass = Text.classnames({ body: { m: true } });
        return [
            ...technicalInformationitems.map(({ typeName, valueMetric, unitMetric = null }) => html `
					<tr class="${bodyTextClass}">
						<td>${typeName}</td>
						<td>${unitMetric ? `${valueMetric} ${unitMetric}` : valueMetric}</td>
					</tr>
				`),
            ...complianceTechnicalItems.map(({ headingText, text }) => html `
					<tr class="${bodyTextClass}">
						<td>${headingText}</td>
						<td>${text}</td>
					</tr>
				`)
        ];
    }
    /**
     * Retreives all objects in complianceTechnical.
     */
    getComplianceTechnical() {
        return (this.product.content?.complianceTechnical?.filter((complianceItem) => complianceItem.headingType !== ProductComplianceTechnicalHeadingTypeEnum.nonRescaled) ?? []);
    }
    /**
     * Retreives all objects in technicalInformation which are not already present in complianceTechnical.
     *
     * @param complianceTechnicalItems ...
     */
    getFilteredTechnicalInformation(complianceTechnicalItems) {
        // Uses 'toUpperCase' as typeName could have the value 'Brand name', where headingText have 'Brand Name'
        return (this.product.content?.technicalInformation?.filter((technicalInformationItem) => !complianceTechnicalItems.some((complianceTechnicalItem) => technicalInformationItem.typeName.toUpperCase() ===
            complianceTechnicalItem.headingText.toUpperCase())) ?? []);
    }
}
__decorate([
    property({ type: Object, required: true })
], EnergyFicheCard.prototype, "product", void 0);
__decorate([
    property({ type: Object, required: true })
], EnergyFicheCard.prototype, "theme", void 0);
__decorate([
    property({ type: Boolean })
], EnergyFicheCard.prototype, "disableLinks", void 0);
//# sourceMappingURL=EnergyFicheCard.js.map